import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import ControlledInputText from 'typescript/components/forms/controlled_input_text';
import ControlledInputPassword from 'typescript/components/forms/controlled_input_password';
import { CHECKOUT_PAGE_CLICK_EVENTS } from 'typescript/constants/tracking';
import { onCheckoutPageClick } from 'typescript/utilities/tracking';

interface FieldsProps {
  personalName?: string | null;
  personalBirthdate?: string | null;
  personalSsn?: string | null;
  trackingData: Record<string, any>;
}

const Fields = ({
  personalName,
  personalBirthdate,
  personalSsn,
  trackingData,
}: FieldsProps) => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  return (
    <>
      <div className={`shop-grid-container shop-grid-item-full`}>
        <ControlledInputText
          className="shop-grid-item-half"
          control={control}
          name="personal_name"
          label={t(
            'checkout.payment_v3.payInInstallments.financingForm.fields.name',
          )}
          disabled={true}
          defaultValue={personalName}
        />
        <ControlledInputText
          className="shop-grid-item-half"
          control={control}
          name="personal_birthdate"
          label={t(
            'checkout.payment_v3.payInInstallments.financingForm.fields.dob',
          )}
          defaultValue={personalBirthdate}
          placeholder="YYYY-MM-DD"
          onClick={() => {
            onCheckoutPageClick({
              eventDesc: CHECKOUT_PAGE_CLICK_EVENTS.financing_dob_field_click,
              trackingData,
            });
          }}
        />
        <ControlledInputPassword
          className="shop-grid-item-full"
          control={control}
          name="personal_ssn"
          label={t(
            'checkout.payment_v3.payInInstallments.financingForm.fields.ssn',
          )}
          defaultValue={personalSsn}
          onClick={() => {
            onCheckoutPageClick({
              eventDesc: CHECKOUT_PAGE_CLICK_EVENTS.financing_ssn_field_click,
              trackingData,
            });
          }}
        />
      </div>
    </>
  );
};

export default Fields;
